import React from 'react';

const PriceSummary = ({ formData, agencies, regions, vehicleTypes }) => {
  const getAgencyName = (id) => {
    const agency = agencies.find(a => a.id.toString() === id.toString());
    return agency ? agency.name : '-';
  };

  const getRegionName = (id) => {
    const region = regions.find(r => r.id.toString() === id.toString());
    return region ? region.name : '-';
  };

  const getVehicleTypeName = (id) => {
    const vehicleType = vehicleTypes.find(v => v.id.toString() === id.toString());
    return vehicleType ? vehicleType.name : '-';
  };

  const formatCurrency = (amount, currency) => {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'EUR' }).format(amount);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Rezervasyon Özeti</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Lütfen rezervasyon bilgilerini kontrol edin ve onaylayın.
          </p>
        </div>
        <div className="border-t border-gray-200">
          <dl>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Acente</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {getAgencyName(formData.agencyId)}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Acente Referans No</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {formData.agencyReference || '-'}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Başlangıç Bölgesi</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {getRegionName(formData.fromRegionId)}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Varış Bölgesi</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {getRegionName(formData.toRegionId)}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Otel</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {formData.hotelName || '-'}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">İkinci Otel</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {formData.secondaryHotelName || '-'}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Araç Tipi</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {getVehicleTypeName(formData.vehicleTypeId)}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Gidiş-Dönüş</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {formData.isRoundTrip ? 'Evet' : 'Hayır'}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Yolcu Sayısı</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {formData.passengerCount}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                {formData.isRoundTrip ? 'Toplam Fiyat' : 'Fiyat'}
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 font-bold">
                {formatCurrency(formData.price, formData.currency)}
                {formData.isRoundTrip && (
                  <span className="ml-2 text-xs font-normal text-gray-500">
                    (Gidiş: {formatCurrency(formData.arrivalPrice, formData.currency)} + 
                     Dönüş: {formatCurrency(formData.returnPrice, formData.currency)})
                  </span>
                )}
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Yolcu Bilgileri</h3>
        </div>
        <div className="border-t border-gray-200">
          <ul className="divide-y divide-gray-200">
            {formData.passengers.map((passenger, index) => (
              <li key={index} className="px-4 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      {passenger.firstName} {passenger.lastName}
                    </p>
                    <p className="text-sm text-gray-500">
                      {passenger.email && `${passenger.email} · `}
                      {passenger.phone && `${passenger.phone} · `}
                      {passenger.nationality && `${passenger.nationality}`}
                    </p>
                  </div>
                  <div className="text-sm text-gray-500">
                    Yolcu #{index + 1}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Transfer Bilgileri</h3>
        </div>
        <div className="border-t border-gray-200">
          <ul className="divide-y divide-gray-200">
            {formData.transfers.map((transfer, index) => (
              <li key={index} className="px-4 py-4">
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {transfer.direction === 'arrival' ? 'Varış Transferi' : 'Dönüş Transferi'}
                  </p>
                  <p className="text-sm text-gray-500">
                    {transfer.date && new Date(transfer.date).toLocaleDateString('tr-TR')} · 
                    {transfer.time} · 
                    {transfer.flightNumber && ` Uçuş: ${transfer.flightNumber}`}
                  </p>
                  <p className="text-sm text-gray-500 mt-1">
                    {transfer.pickupLocation && `Alış: ${transfer.pickupLocation}`} · 
                    {transfer.dropoffLocation && ` Bırakış: ${transfer.dropoffLocation}`}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">İletişim Bilgileri</h3>
        </div>
        <div className="border-t border-gray-200">
          <ul className="divide-y divide-gray-200">
            {formData.contactDetails.map((contact, index) => (
              <li key={index} className="px-4 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      {contact.type === 'email' ? 'E-posta' : contact.type === 'phone' ? 'Telefon' : 'WhatsApp'}
                    </p>
                    <p className="text-sm text-gray-500">
                      {contact.value}
                    </p>
                  </div>
                  {contact.isPrimary && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Birincil
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-green-50 border-l-4 border-green-400 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-green-700">
              Rezervasyon bilgilerinizi kontrol ettikten sonra "Rezervasyonu Oluştur" butonuna tıklayarak işlemi tamamlayabilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
